import React from "react";

const PauseModal = ({
  isOpen,
  title,
  subtitle,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
      <div className="login-container bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
        <svg
          className="w-20 h-20 text-red-600 mx-auto"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <h3 className="text-xl text-center font-normal text-gray-500 mt-5 mb-6">
          {title}
        </h3>
        <p className="text-sm mb-4 text-center">{subtitle}</p>
      </div>
    </div>
  );
};

export default PauseModal;
